import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startPostCarretero } from "../../../../context/actions/asistenciasActions";

const nuevaFila = () => ({ tipoCosto: undefined, cantidad: "", costo: "" });

export const useForm = (asistencia) => {
  const dispatch = useDispatch();
  const loadingConfirmarProveedor = useSelector(
    (state) => state.asistenciasReducer.loadingConfirmarProveedor
  );
  const { sucursales } = useSelector(
    (state) => state.proveedorInfoReducer.proveedorInfo
  );
  const [filas, setFilas] = React.useState([nuevaFila()]);
  const [body, setBody] = React.useState({
    ProveedorPropuestoID: asistencia.proveedorPropuestoID,
    tiempoLlegadaPropuesto: "",
  });

  const soloUnaSucursal = sucursales?.length === 1;
  const textoSucursal = soloUnaSucursal ? sucursales[0].nombre : "";

  useEffect(() => {
    if (soloUnaSucursal) {
      setBody((actual) => ({
        ...actual,
        proveedorSucursalID: sucursales[0].proveedorSucursalID,
      }));
    }
  }, [soloUnaSucursal, sucursales]);

  const resetForm = () => {
    setFilas([nuevaFila()]);
    setBody({
      ProveedorPropuestoID: asistencia.proveedorPropuestoID,
      tiempoLlegadaPropuesto: "",
      ...(soloUnaSucursal && {
        proveedorSucursalID: sucursales[0].proveedorSucursalID,
      }),
    });
  };

  const handleChange = ({ target }) =>
    setBody({ ...body, [target.name]: Number(target.value) });

  const changeSelect = (proveedorSucursalID) =>
    setBody({ ...body, proveedorSucursalID });

  const actualizarFila = (index, campo, valor) =>
    setFilas(
      filas.map((fila, i) =>
        i === index ? { ...fila, [campo]: valor } : fila
      )
    );

  const agregarFila = () => setFilas([...filas, nuevaFila()]);

  const eliminarFila = (index) =>
    setFilas(filas.filter((fila, i) => i !== index));

  const costoPropuesto = filas.reduce(
    (total, item) => total + Number(item.cantidad) * Number(item.costo),
    0
  );

  const handleOk = () =>
    dispatch(
      startPostCarretero({
        ...body,
        costoPropuesto,
        desgloseItems: filas.map((item) => ({
          ...item,
          cantidad: Number(item.cantidad),
          costo: Number(item.costo),
        })),
      })
    );

  return {
    soloUnaSucursal,
    textoSucursal,
    handleOk,
    handleChange,
    changeSelect,
    body,
    filas,
    actualizarFila,
    agregarFila,
    eliminarFila,
    costoPropuesto,
    resetForm,
    loadingConfirmarProveedor,
  };
};
